import React, { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import HeatMap from "react-heatmap-grid";
// Components
import { GraphicContainer, GraphicRotateDiv, HeaderDiv, GraphicTitle, LegendDiv, LegendColorDiv, GraphicSizeDiv, AxisX } from "./styles";

const DifficultyPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [difficultyValues, setDifficultyValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let difficultyRecordings = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      let difficultyValue = "Empty";

      if (!recording.hasOwnProperty("difficultyLevel")) return difficultyRecordings.push(difficultyValue);

      const difficultyLevel = recording.difficultyLevel.toLowerCase();
      if (difficultyLevel === "easy") difficultyValue = "Easy";
      if (difficultyLevel === "medium") difficultyValue = "Medium";
      if (difficultyLevel === "hard") difficultyValue = "Hard";

      difficultyRecordings.push(difficultyValue);
    });

    setPositions(positions);
    setDifficultyValues(difficultyRecordings);

    return () => {
      setPositions([]);
      setDifficultyValues([]);
    };
  }, [recordings]);

  const getColor = (value) => {
    if (value === "Easy") return "#b2df8a";
    if (value === "Medium") return "#fdbf6f";
    if (value === "Hard") return "#e31a1c";

    return "#fff";
  };

  return (
    <GraphicContainer ref={ref}>
      <GraphicRotateDiv>
        <HeaderDiv>
          <GraphicTitle>{t("reports.difficultyGraphic.title")}</GraphicTitle>
        </HeaderDiv>
        <LegendDiv>
          <p>Easy</p>
          <LegendColorDiv color="#b2df8a" margin="0 10px 0 5px" />
          <p>Medium</p>
          <LegendColorDiv color="#fdbf6f" margin="0 10px 0 5px" />
          <p>Hard</p>
          <LegendColorDiv color="#e31a1c" margin="0 0 0 5px" />
        </LegendDiv>
        <GraphicSizeDiv align={positions.length >= 32 ? "left" : "center"}>
          <HeatMap
            xLabels={positions}
            yLabels={[""]}
            yLabelWidth={0}
            data={[difficultyValues]}
            squares
            height={25}
            xLabelsLocation={"bottom"}
            cellStyle={(background, value) => ({
              background: getColor(value),
              border: "1px solid #e0e0e0",
              fontSize: "18px",
              paddingBottom: "3px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "default",
            })}
            cellRender={(value) => (value === "On" ? "+" : "")}
          />
        </GraphicSizeDiv>
        <AxisX>{t("reports.difficultyGraphic.axisX")}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
});

export default DifficultyPlot;
